import EditQuestionContainer from './EditQuestionContainer';

export default EditQuestionContainer;